export default "__VITE_ASSET__ST9$0oQi__"